export function createPaginationNavigationGuard() {
  let generation = 0;
  let loading = false;

  return {
    reset() {
      generation++;
      loading = false;
    },

    async run(task) {
      if (loading) return false;
      const owner = ++generation;
      loading = true;
      try {
        await task();
        return true;
      } finally {
        if (owner === generation) loading = false;
      }
    },
  };
}
